"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTextAreaFactory = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var factory_1 = require("../internal/factory");
var units_1 = require("../internal/units");
var Field_1 = require("../internal/components/Field");
var DebouncedTextArea_1 = require("../internal/components/DebouncedTextArea");
var unitToStyle_1 = require("../internal/unitToStyle");
var stateSettings = {
    textarea: {
        type: 'Object',
        required: false,
        properties: {
            palette: {
                type: 'Object',
                required: false,
                properties: {
                    text: units_1.UNITS.COLOR.asOptional(),
                    background: units_1.UNITS.COLOR.asOptional(),
                    border: units_1.UNITS.COLOR.asOptional()
                }
            }
        }
    }
};
exports.FieldTextAreaFactory = factory_1.factory({
    name: 'FieldTextArea',
    settings: __assign(__assign({}, Field_1.FIELD_SETTINGS), { textarea: {
            type: 'Object',
            properties: {
                debounceTimeout: { type: 'Number', minimum: 0, default: 0 },
                rows: { type: 'Number', minimum: 0 },
                resize: { type: 'String', required: false, options: ['none', 'both', 'vertical', 'horizontal'] },
                padding: units_1.UNITS.PADDING,
                font: units_1.UNITS.FONT,
                border: units_1.UNITS.BORDER.asOptional(),
                palette: {
                    type: 'Object',
                    properties: {
                        text: units_1.UNITS.COLOR,
                        placeholder: units_1.UNITS.COLOR,
                        background: units_1.UNITS.COLOR,
                        border: units_1.UNITS.COLOR.asOptional()
                    }
                }
            }
        } }),
    $when: {
        invalid: stateSettings,
        readonly: stateSettings,
        disabled: stateSettings,
        focus: stateSettings,
        hover: stateSettings
    },
    component: function (_a) {
        var _b;
        var settings = _a.settings, $when = _a.$when;
        var error = settings.error, label = settings.label, textarea = settings.textarea;
        // Generate Field component to place label and error
        var Field = Field_1.makeField({ error: error, label: label });
        var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* textarea is a growing flex item */\n      flex-grow: 1;\n      flex-shrink: 1;\n      align-self: stretch;\n      flex-basis: 100%;\n\n      /* We need position relative to place the disable icon */\n      position: relative;\n    "], ["\n      /* textarea is a growing flex item */\n      flex-grow: 1;\n      flex-shrink: 1;\n      align-self: stretch;\n      flex-basis: 100%;\n\n      /* We need position relative to place the disable icon */\n      position: relative;\n    "])));
        var styleByState = function (state) {
            var _a, _b, _c, _d, _e, _f;
            return state !== undefined
                ? styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n          "])), unitToStyle_1.ifDefined('color', (_b = (_a = state === null || state === void 0 ? void 0 : state.textarea) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.text), unitToStyle_1.ifDefined('background-color', (_d = (_c = state === null || state === void 0 ? void 0 : state.textarea) === null || _c === void 0 ? void 0 : _c.palette) === null || _d === void 0 ? void 0 : _d.background), unitToStyle_1.ifDefined('border-color', (_f = (_e = state === null || state === void 0 ? void 0 : state.textarea) === null || _e === void 0 ? void 0 : _e.palette) === null || _f === void 0 ? void 0 : _f.border)) : '';
        };
        var TextArea = styled_components_1.default(DebouncedTextArea_1.DebouncedTextArea)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      /* Reset default textarea styling */\n      border: none;\n      &:focus {\n        outline: none;\n      }\n\n      /* Show or hide the resize widget */\n      resize: ", ";\n\n      box-sizing: border-box;\n      width: 100%;\n\n      /* Add font, padding and border styling */\n      ", "\n      ", "\n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      /* Style textarea in default state using its palette */\n      ", "\n\n      /* Style in each available state */\n      &:focus {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n\n      &[aria-invalid='true'] {\n        ", "\n      }\n\n      &:disabled {\n        ", "\n      }\n\n      &:read-only {\n        ", "\n      }\n    "], ["\n      /* Reset default textarea styling */\n      border: none;\n      &:focus {\n        outline: none;\n      }\n\n      /* Show or hide the resize widget */\n      resize: ", ";\n\n      box-sizing: border-box;\n      width: 100%;\n\n      /* Add font, padding and border styling */\n      ", "\n      ", "\n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      /* Style textarea in default state using its palette */\n      ", "\n\n      /* Style in each available state */\n      &:focus {\n        ", "\n      }\n\n      &:hover {\n        ", "\n      }\n\n      &[aria-invalid='true'] {\n        ", "\n      }\n\n      &:disabled {\n        ", "\n      }\n\n      &:read-only {\n        ", "\n      }\n    "])), (_b = textarea.resize) !== null && _b !== void 0 ? _b : 'none', unitToStyle_1.fontToStyle(textarea.font), unitToStyle_1.paddingToStyle(textarea.padding), textarea.border !== undefined ? unitToStyle_1.borderToStyle(textarea.border) : '', textarea.palette.placeholder, styleByState({ textarea: { palette: textarea.palette } }), styleByState($when.focus), styleByState($when.hover), styleByState($when.invalid), styleByState($when.disabled), styleByState($when.readonly));
        return function (_a) {
            var _b;
            var disabled = _a.disabled, readOnly = _a.readOnly, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, fieldProps = __rest(_a, ["disabled", "readOnly", "placeholder", "value", "onChange", "onBlur"]);
            // Prepare onBlur and onChange handlers
            var _onBlur = readOnly === true ? undefined : onBlur;
            var _onChange = readOnly === true ? undefined : function (e) { return onChange(e.target.value); };
            // Default timeout to zero if not passed
            var timeout = (_b = settings.textarea.debounceTimeout) !== null && _b !== void 0 ? _b : 0;
            return (react_1.default.createElement(Field, __assign({}, fieldProps), function (props) { return (react_1.default.createElement(Container, null,
                react_1.default.createElement(TextArea, __assign({}, props, { debounceTimeout: timeout, rows: textarea.rows, disabled: disabled, readOnly: readOnly, placeholder: placeholder, value: value, onChange: _onChange, onBlur: _onBlur })))); }));
        };
    }
});
var templateObject_1, templateObject_2, templateObject_3;
